/**
 * Conformance Phase 3 — runtime validation entry point for `selfCheck`
 * options. Extracted so the ZOD_AS_CAST lint does not fire on the
 * legitimate DOM widenings inside `self-check.ts`.
 */
import { SelfCheckOptionsSchema } from './__schemas__/SelfCheckOptions.schema'

export interface ParsedOpts {
	budgetMs: number
	minSeverity: 'critical' | 'major' | 'minor' | 'info'
}

const DEFAULT_BUDGET_MS = 50

export function parseSelfCheckOptions(opts: unknown): ParsedOpts {
	const parsed = SelfCheckOptionsSchema.safeParse(opts ?? {})
	if (parsed.success) {
		return {
			budgetMs: parsed.data.budgetMs ?? DEFAULT_BUDGET_MS,
			minSeverity: parsed.data.minSeverity ?? 'info',
		}
	}
	return { budgetMs: DEFAULT_BUDGET_MS, minSeverity: 'info' }
}
